module.exports = __webpack_public_path__ + "img/m_hydol_top480.8fe23af6.jpg";